<template>
  <div class="" :data-testid="`financialclose_component_bulkupload__root-${uploadType}`">
  <v-btn 
    v-if="!hideButton"
    color="secondaryBtn" 
    class="mr-1" 
    @click="openBulkUpload()" 
    :data-testid="`financialclose_component_bulkupload__open-drawer-btn-${uploadType}`"
  >
        <img src="/img/icons/fbc-icons/ImportTask.svg" alt="Bulk Upload" class="pr-2">
        <span class="">{{ buttonLabel }}</span>
      </v-btn>
      <lb-drawer 
        :Maxwidth="(uploaddata.length > 0) ? '1665' : '700'" 
        v-model="dialog" 
        :heading="drawerHeading" 
        :loading="loading" 
        :data-testid="`financialclose_component_bulkupload__drawer-${uploadType}`"
      >
        <template v-slot:body>
          <div data-testid="financialclose_component_checklist_bulkupload__drawer-body">
            <div class="d-flex align-center justify-space-between " data-testid="financialclose_component_checklist_bulkupload__drawer-header">
              <span class="text-center mb-1" v-if="uploaddata.length === 0" data-testid="financialclose_component_checklist_bulkupload__upload-prompt">Upload your document</span>
              <span v-else data-testid="financialclose_component_checklist_bulkupload__preview-label">Preview</span>

              <div class="d-flex gap-2" data-testid="financialclose_component_checklist_bulkupload__drawer-header-btns">
                <v-btn text class="secondaryBtn" v-if="uploaddata.length>0" @click="resetUploadData" data-testid="financialclose_component_checklist_bulkupload__reupload-btn"> <v-icon>mdi-reload</v-icon><span>Re-Upload</span> </v-btn>
                <v-btn  class="secondaryBtn d-flex align-center mb-2"
                  @click="downloadTemplate()" data-testid="financialclose_component_checklist_bulkupload__download-template-btn"><span>Download Template</span></v-btn>
              </div>
            </div>
            <div class="d-flex align-center justify-space-between " v-if="uploaddata.length > 0" data-testid="financialclose_component_checklist_bulkupload__show-errors-checkbox-row">
              <v-checkbox  color="caccounting" v-model="showdatawitherror" data-testid="financialclose_component_checklist_bulkupload__show-errors-checkbox"> 
                <template v-slot:label>
                <span>Show only items with error</span>
              </template>
              </v-checkbox>
              <v-spacer></v-spacer>
            </div>
          </div>
            <div class="d-flex align-center justify-center" data-testid="financialclose_component_checklist_bulkupload__dragdrop-panel">
              <DragDropfile v-if="uploaddata.length === 0" hidedetails :files="file" @update:files="updateFilesBulk" data-testid="financialclose_component_checklist_bulkupload__dragdrop-component"  />
          </div>   
          
          <!-- Checklist Table -->
          <div v-if="uploaddata.length > 0 && uploadType === 'checklist'" class="radius-small border-on simple-table " style="max-height:73vh; overflow:scroll" data-testid="financialclose_component_checklist_bulkupload__table-panel">
            <v-simple-table data-testid="financialclose_component_checklist_bulkupload__table">
              <template v-slot:default>
                <thead class="tableHeaderBg" data-testid="financialclose_component_checklist_bulkupload__table-header">
                  <th class="text-center tableHeaderBg" scope="sno" data-testid="financialclose_component_checklist_bulkupload__table-header-col-sno">S No.</th>
                  <th 
                    v-for="header in computedHeaders" 
                    :key="header.value" 
                    class="text-center tableHeaderBg" 
                    :scope="header.value" 
                    :data-testid="`financialclose_component_checklist_bulkupload__table-header-col-${header.value}`"
                  >
                    {{ header.text }}
                  </th>
                </thead>
                <v-slide-y-transition group tag="tbody" style="overflow:hidden !important;">
                  <tr
                  v-for="(row, index) in filteredData"
                  :key="index"
                  :data-testid="`financialclose_component_checklist_bulkupload__table-row-${index}`"
                  >
                  <td data-testid="financialclose_component_checklist_bulkupload__table-row-serial">{{ index + 1 }}</td>
                  <template v-for="header in computedHeaders">
                      <!-- Error cell -->
                      <td v-if="errorsonly[index] && errorsonly[index][header.value]" :key="`error-${header.value}`" class="font-size-xm pa-0  border-right-data" :data-testid="`financialclose_component_checklist_bulkupload__table-cell-${header.value}-error`" >
                        <div class="all-width all-height error--text pa-2">
                          <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                v-if="header.value === 'assertions' || header.value === 'location'"
                                class="d-inline-block"
                              >
                                <v-chip
                                  v-for="(error, errorKey) in (errorsonly[index][header.value] || []).split(',')"
                                  :key="errorKey"
                                  label
                                  v-bind="attrs"
                                  v-on="on"
                                  color="error"
                                 
                                  outlined
                                  class="pl-2 mb-1 mr-1"
                                  :data-testid="`financialclose_component_checklist_bulkupload__chip-error-${errorKey}`"
                                >
                                  <span class="pl-1">{{ error.trim() }}</span>
                                </v-chip>
                              </div>
                              <span v-else v-bind="attrs" v-on="on">
                                {{ errorsonly[index][header.value] }}
                              </span>
                            </template>
                          </v-tooltip>
                        </div>
                      </td>
                      <!-- Data cell -->
                      <td v-else :key="`cell-${header.value}`" :data-testid="`financialclose_component_checklist_bulkupload__table-cell-${header.value}`">
                        <div v-if="(header.value === 'tags' || header.value === 'location') && row[header.value] && row[header.value].length > 0" class="d-flex align-center">
                          <v-chip label outlined class="lightpurple caccounting--text pl-2 mb-1 mr-1" data-testid="financialclose_component_checklist_bulkupload__chip-main">
                            <span class="pl-1">{{ row[header.value][0] }}</span>
                          </v-chip>
                          <span v-if="row[header.value].length > 1" class="border-on px-1 radius-small font-size-xs font-weight-medium" data-testid="financialclose_component_checklist_bulkupload__chip-more">+{{ row[header.value].length - 1 }}</span>
                        </div>
                        <div v-else-if="header.value === 'approver' || header.value === 'preparer'">
                          <v-avatar v-for="(va, ka) in (row[header.value] || [])" :key="ka" size="28" class="primary white--text mb-1 mr-1" :data-testid="`financialclose_component_checklist_bulkupload__avatar-${header.value}-${ka}`">
                            <v-tooltip top content-class="tooltip-top">
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="text-uppercase font-weight-medium">{{ va[0] }}</span>
                              </template>
                              <span>{{ va }}</span>
                            </v-tooltip>
                          </v-avatar>
                        </div>
                        <div v-else-if="header.value === 'assertions'" class="d-flex align-center">
                          <span v-if="row[header.value]?.length >= 1" data-testid="financialclose_component_checklist_bulkupload__assertion-main">
                            {{ row[header.value][0] }}
                          </span>
                          <span v-if="row[header.value] && row[header.value].length > 1" class="border-on px-1 ml-1 radius-small font-size-xs font-weight-medium" data-testid="financialclose_component_checklist_bulkupload__assertion-more">+{{ row[header.value].length - 1 }}</span>
                        </div>
                        <div v-else-if="header.value === 'glcode'">
                          <div v-for="(va, ka) in (row[header.value] || [])" :key="ka" outlined class="pl-2 mb-1 mr-1" :data-testid="`financialclose_component_checklist_bulkupload__glcode-chip-${ka}`">
                              <span class="pl-1">{{ va}}</span>
                          </div>
                        </div>
                        <div v-else-if="header.value === 'task_type'">
                          <span v-if="row[header.value] === LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME">
                          {{LEGACY_TASK_TYPE_LABEL_CHECKLIST}} Task
                          </span>
                          <span v-else>
                            {{ row[header.value]}}
                          </span>
                        </div> 
                        <div v-else class="two-line-clamp">{{ row[header.value] }}</div>
                      </td>
                    </template>
                  </tr>
                </v-slide-y-transition>
              </template>
            </v-simple-table>
            
          </div>

          <!-- Trial Balance Table -->
          <div 
            v-if="uploaddata.length > 0 && uploadType === 'trialbalance'" 
            class="mt-3"
            :data-testid="`financialclose_component_bulkupload__table-section-trialbalance`"
          >
            <v-simple-table 
              fixed-header 
              class="simple-table border-on radius-small"
              :data-testid="`financialclose_component_bulkupload__table-trialbalance`"
            >
              <template>
                <thead class="tableHeaderBg">
                  <tr>
                    <th class="pa-1 tableHeaderBg text-center">S No.</th>
                    <th 
                      v-for="header in computedHeaders" 
                      :key="header.value" 
                      class="pa-1 tableHeaderBg text-center" 
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </thead>
                <v-slide-y-transition group tag="tbody">
                  <tr v-for="(v, k) in filteredData" :key="k">
                    <td class="text-center">{{ k + 1 }}</td>
                    <td 
                      v-for="header in computedHeaders" 
                      :key="`cell-${header.value}`"
                      :class="[
                        header.align ? `text-${header.align}` : 'text-left',
                        { 'all-width all-height border-red': dataerror[k]?.[0]?.[header.errorIndex] && dataerror[k][0][header.errorIndex] !== '' }
                      ]"
                    >
                      <v-tooltip 
                        v-if="dataerror[k]?.[0]?.[header.errorIndex] && dataerror[k][0][header.errorIndex] !== ''" 
                        bottom 
                        content-class="tooltip-bottom"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">{{ getCellValue(v, header.value) }}</div>
                        </template>
                        <span>{{ dataerror[k][0][header.errorIndex] }}</span>
                      </v-tooltip>
                      <span 
                        v-else-if="header.value === 'location' && dataerror[k]?.[0]?.[5]" 
                        class="error--text pa-1 mr-1 radius-mini"
                      >
                        {{ dataerror[k][0][5] }}
                      </span>
                      <span 
                        v-else 
                        :class="header.value === 'location' ? 'caccounting--text pa-1 mr-1 radius-mini' : ''"
                      >
                        {{ formatCellValue(getCellValue(v, header.value), header.format) }}
                      </span>
                    </td>
                  </tr>
                </v-slide-y-transition>
              </template>
            </v-simple-table>
          </div>

          <!-- Error Messages Section (Common for both Checklist and Trial Balance) -->
          <div v-if="(flag && uploadType === 'checklist') || (haserror && uploadType === 'trialbalance') || (tberrorflag && uploadType === 'trialbalance')" class="error--text ma-0 pa-0 mt-4">
            
            <!-- Common Error Message -->
            <p class="font-size-xm" data-testid="financialclose_component_bulkupload__error-msg">
              *These are fields where errors exist / information missing. Please rectify and re-upload to continue.
              <span v-if="uploadType === 'checklist'">(Note: Preparer & Approver cannot be the same user)</span>
            </p>
            
            <!-- Header Errors (Common) -->
            <div v-if="headerErrorMessages.length" class="ma-0 pa-0 mt-2 font-size-xm" data-testid="financialclose_component_bulkupload__header-errors">
              <strong>Header Issues Detected:</strong>
              <div
                :style="headerErrorMessages.length > 2
                ? 'max-height:70px; overflow-y:auto; scrollbar-width:thin;'
                : ''"
                class="mt-1 pr-1"
                data-testid="financialclose_component_bulkupload__header-errors-list"
              >
                <div v-for="(msg,index) in headerErrorMessages" :key="index" class="mb-1" :data-testid="`financialclose_component_bulkupload__header-error-${index}`">
                  - {{ msg }}
                </div>
              </div>
            </div>
            
            <!-- Data Errors (Common) -->
            <div v-if="errorsonly.length > 0" class="ma-0 pa-0 mt-2 font-size-xm" data-testid="financialclose_component_bulkupload__row-errors">
              <strong>Data Errors:</strong>
              <div class="mt-1 pr-1">
                <div v-for="(errorObj, index) in errorsonly" :key="index" class="mb-1" :data-testid="`financialclose_component_bulkupload__row-error-${index}`">
                  <div v-for="(msg, i) in Object.values(errorObj)" :key="i" class="mb-1 noTransform" :data-testid="`financialclose_component_bulkupload__row-error-msg-${index}-${i}`">
                    {{ `Row ${(index + 1)}: ` + msg.trim() || 'Error in row ' + (index + 1) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <div v-if="uploaddata.length > 0">
            <v-btn 
              class="ml-2 white--text" 
              color="primary" 
              v-if="!flag && (uploadType === 'checklist' || !tberrorflag)" 
              @click="uploadData()" 
              data-testid="financialclose_component_checklist_bulkupload__upload-btn"
            >
              <span>Upload</span>
            </v-btn>
            <v-btn class="secondaryBtn" @click="cleardata()" data-testid="financialclose_component_checklist_bulkupload__cancel-btn"><span>Cancel</span></v-btn>
          </div>
        </template>
      </lb-drawer>
    </div>
  </template>
  
<script>
import DragDropfile from '../../../../views/Inputs/DragDropfile.vue';
import { parseCommaSeparatedField, formatDateToDMY, parseDueDateValue } from '../../utils/utils';
import { LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME, LEGACY_TASK_TYPE_LABEL_CHECKLIST } from '../../utils/constants';
import { CHECKLIST_VALIDATION_MESSAGES, TRIAL_BALANCE_VALIDATION_MESSAGES, GENERAL_ERROR_MESSAGES, HEADER_ERROR_MESSAGES } from '../../utils/bulkUploadValidationMessages';
  export default {
    name: 'financialclose_component_checklist_bulkupload',
    // props: ['props'],
    props: {
    uploadType: {
      type: String,
      required: true,
      validator: (value) => ['checklist', 'trialbalance'].includes(value),
      default: 'checklist'
    },
    project: {
      type: String,
    },
    cycle_type: {
      type: String,
    },
    customColumns: {
      type: Array,
      default: () => []
    },
    expectedHeadings: {
      type: Array,
      default: () => []
    },
    chartOfAccounts: {
      type: Array,
      default: () => []
    },
    activeUsers: {
      type: Array,
      default: () => []
    },
    existingTrialBalanceData: {
      type: Array,
      default: () => []
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    buttonLabel: {
      type: String,
      default: 'Bulk Upload'
    }
  },
    data: function () {
      return {
        right: this.uploadType === 'checklist' ? 'financialclose_master_checklist' : 'financialclose_project',
        file: null,
        fileprocessing: {},
        flag: false,
        tberrorflag: false,
        uploaddata: [],
        dataerror: [],
        dialog: false,
        loading: false,
        showdatawitherror:false,
        errorsonly:[],
        validLocationsSet: null,
        headerErrorMessages: [],
        haserror: false,
        LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME,
        LEGACY_TASK_TYPE_LABEL_CHECKLIST,
      }
    },
    created() {
      this.dataerror=[]
    },
    activated() {
    },
 
    components:{
      DragDropfile
    },
    methods: {
      // ============================================
      // SHARED ERROR HANDLING UTILITIES
      // ============================================
      
      /**
       * Flatten trial balance errors to match checklist error format
       * Converts nested error structure to flat error objects with row numbers
       */
      flattenTrialBalanceErrors(errordata, grouporder) {
        let flattenedErrors = [];
        let rowCounter = 0;
        
        for (const group of grouporder) {
          if (errordata[group]) {
            for (let j = 0; j < errordata[group].length; j++) {
              const errorArray = errordata[group][j];
              let errorObj = {};
              let hasError = false;
              
              errorArray.forEach((errorMsg, idx) => {
                if (errorMsg && errorMsg !== '') {
                  errorObj[`error_${idx}`] = `Row ${rowCounter + 1}: ${errorMsg}`;
                  hasError = true;
                }
              });
              
              if (hasError) {
                flattenedErrors.push(errorObj);
              }
              rowCounter++;
            }
          }
        }
        
        return flattenedErrors;
      },
      
      /**
       * Show error in drawer with proper upload type context
       * Used for critical errors that prevent data upload
       * @param {string} errorMessage - The error message to display
       * @param {boolean} isHeaderError - If true, shows under "Header Issues Detected", otherwise under "Data Errors"
       */
      showErrorInDrawer(errorMessage, isHeaderError = false) {
        this.haserror = true;
        
        if (this.uploadType === 'trialbalance') {
          this.tberrorflag = true;
        } else {
          this.flag = true;
        }
        
        this.uploaddata = [];
        this.dataerror = [];
        
        // Show in appropriate section based on error type
        if (isHeaderError) {
          this.headerErrorMessages = [errorMessage];
          this.errorsonly = [];
        } else {
          this.errorsonly = [{ error_0: errorMessage }];
          this.headerErrorMessages = [];
        }
        
        this.dialog = true;
      },
      
      /**
       * Reset all upload-related data and error states
       * Common for both checklist and trial balance
       */
      resetUploadData() {
        this.uploaddata = [];
        this.showdatawitherror = false;
        this.file = null;
        this.dataerror = [];
        this.flag = false;
        this.errorsonly = [];
        this.headerErrorMessages = [];
        this.haserror = false;
        this.tberrorflag = false;
      },
      
      // ============================================
      // DRAWER & UI CONTROL METHODS
      // ============================================
      
      init() {
      },
      
      openBulkUpload(){
        this.resetUploadData();
        this.dialog = true;
      },

      
      /**
       * Download appropriate template based on upload type
       */
      downloadTemplate(){
        if (this.uploadType === 'checklist') {
          if(this.project) {
            this.$nova.downloadFile('', {}, `/v2/financialclose/analysis/getbulkchecklisttemplate/${this.project ? this.project : ''}`);
          } else {
            this.$nova.downloadFile('', {}, `/v2/financialclose/masters/checklist/getbulksubmittemplate/${this.cycle_type ? `${this.cycle_type}` : ''}`);
          }
        } else if (this.uploadType === 'trialbalance') {
          this.$nova.downloadFile('', {}, '/v2/financialclose/analysis/getuploadtbtemplate');
        }
      },
      
      /**
       * Clear all data and close drawer
       */
      cleardata(){
        this.file =  null;
        this.fileprocessing =  {};
        this.flag =  false;
        this.tberrorflag = false;
        this.uploaddata =  [];
        this.dataerror =  [];
        this.dialog =  false;
        this.loading =  false;
        this.showdatawitherror = false;
        this.errorsonly = [];
        this.headerErrorMessages = [];
        this.haserror = false;
      },
      
      // ============================================
      // FILE READING & PROCESSING
      // ============================================
      
      /**
       * Main file reading dispatcher - routes to appropriate handler
       */
      async readFile(key) {
        if (this.uploadType === 'checklist') {
          await this.readChecklistFile(key);
        } else if (this.uploadType === 'trialbalance') {
          await this.readTrialBalanceFile(key);
        }
      },
      /**
       * Read and validate checklist Excel file
       * Processes checklist-specific columns and validation rules
       */
      async readChecklistFile(key) {
        this.headerErrorMessages = [];
        
        // ===== CHECKLIST ERROR UTILITIES =====
        
        // Utility: add (or aggregate) error message(s) for a given field
        const addError = (rowErrorBag, fieldName, message = " ") => {
          if (!rowErrorBag[fieldName]) {
            rowErrorBag[fieldName] = message;
          } else {
            rowErrorBag[fieldName] = Array.isArray(rowErrorBag[fieldName])
              ? [...rowErrorBag[fieldName], message]
              : [rowErrorBag[fieldName], message];
          }
        };

        // Utility: normalize error objects so array messages become joined text (for table display)
        const normalizeErrorData = (rawErrorArray) => {
              return rawErrorArray.map(errorObject => {
            const normalized = {};
            Object.keys(errorObject).forEach(fieldKey => {
              normalized[fieldKey] = Array.isArray(errorObject[fieldKey])
                ? errorObject[fieldKey].join(',')
                : errorObject[fieldKey];
            });
            return normalized;
          });
        };


        const currentFile = this.file;
        if ((currentFile || {}).name && (this.fileprocessing[key] || 0) === 0) {
          // ===== CHECKLIST VALIDATION SETUP =====
          // Base headings (in strict order) expected from template
          // Append custom column display names with date suffix for date-type columns
          const customColumnHeadings = this.customColumns.map(customColumn => 
            customColumn.dataType === 'date' 
              ? `${customColumn.displayText} (dd/mm/yyyy)` 
              : customColumn.displayText
          ) || [];
          
          let expectedHeadings = [
            ...this.expectedHeadings,
            ...customColumnHeadings
          ];
      
          this.loading = true;
          this.fileprocessing[key] = 1;

          const fileExtension = ((currentFile || {}).name || "").split(".").pop();

          Promise.resolve()
        // 1. Validate extension
        .then(() => {
          const allowedExtensions = ["xlsx", "xls", "xlsm", "xlsb"];
          if (allowedExtensions.indexOf(fileExtension) === -1) {
            this.uploaddata = [];
            this.dataerror = [{ description: GENERAL_ERROR_MESSAGES.EXTENSION_NOT_SUPPORTED }];
            this.errorsonly = this.dataerror;
            this.flag = true;
            throw new Error(GENERAL_ERROR_MESSAGES.EXTENSION_NOT_SUPPORTED);
          }
          // 2. Read the Excel sheet "TOP SHEET"
          return this.$nova.readExcelFile(currentFile, "TOP SHEET");
        })
        // 3. Process sheet data
        .then(async (sheetData) => {
          const headerRow = sheetData[0] || [];
          const headerIssues = {};

          // Validate each expected heading by index
          expectedHeadings.forEach((expectedTitle, positionIndex) => {
            const incomingTitle = headerRow[positionIndex];
            if (!incomingTitle) {
          addError(headerIssues, expectedTitle, HEADER_ERROR_MESSAGES.MISSING_COLUMN(expectedTitle, positionIndex + 1));
            } else if (incomingTitle.toString().trim().toLowerCase() !== expectedTitle.toLowerCase()) {
          addError(
            headerIssues,
            expectedTitle,
            HEADER_ERROR_MESSAGES.WRONG_COLUMN(expectedTitle, incomingTitle, positionIndex + 1)
          );
            }
          });

          // Extra unexpected columns beyond what is defined
          if (headerRow.length > expectedHeadings.length) {
            for (let unexpectedIndex = expectedHeadings.length; unexpectedIndex < headerRow.length; unexpectedIndex++) {
          addError(
            headerIssues,
            'description',
            HEADER_ERROR_MESSAGES.EXTRA_COLUMN(headerRow[unexpectedIndex], unexpectedIndex + 1)
          );
            }
          }

          // If header problems exist, stop further processing
          if (Object.keys(headerIssues).length > 0) { 
            // Build flat list of header messages
            this.headerErrorMessages = Object.values(headerIssues)
              .map(v => Array.isArray(v) ? v : [v])
              .flat()
              .filter(Boolean);
            this.flag = true;
            this.uploaddata = [];
            this.dataerror = [];
            this.errorsonly = [];
            return;
          }

          const parsedRows = [];
          const perRowErrors = [];
          this.flag = false;

          // Get COA category/subcategory sets from formDataV3 (already cached in store)
          const formData = this.$store.getters['tasks/getFormDataV3'] || await this.$store.dispatch('tasks/fetchFormDataV3');
          const coaCategorySet = new Set(formData?.coaCategoryAcc || []);
          const coaSubcategorySet = new Set(formData?.coaSubcategoryAcc || []);

          // Fetch TB records on-demand for GL code validation
          let validGlCodeSet = new Set();
          try {
            const projectId = this.project;
            if (projectId) {
              const tbResult = await this.$store.dispatch('tasks/fetchTbPage', {
                projectId,
                page: 1,
                limit: 0,
                search: null,
                location: null,
                append: false,
              });
              const tbRecords = tbResult?.records || this.$store.getters['tasks/getTbRecords'] || [];
              validGlCodeSet = new Set(tbRecords.map(record => record.glcode).filter(Boolean));
            }
          } catch (tbError) {
            console.error('[BulkUploadChecklistV2] Failed to fetch TB for GL validation:', tbError);
          }

          // Fetch valid locations once (cache in component)
          if (!this.validLocationsSet) {
            try {
          const locationsResponse = await this.axios.post("/v2/financialclose/location/get");
          if (locationsResponse.data && locationsResponse.data.status === "success") {
            const allLocationNames = (locationsResponse.data.data || [])
              .map(locationObj => (locationObj.name).toString().trim())
              .filter(Boolean);
            this.validLocationsSet = new Set(allLocationNames.map(loc => loc.toLowerCase()));
          } else {
            this.validLocationsSet = new Set();
            this.flag = true;
            perRowErrors.push({ location: GENERAL_ERROR_MESSAGES.FAILED_LOAD_LOCATIONS });
          }
            } catch (locationError) {
          this.validLocationsSet = new Set();
          this.flag = true;
          perRowErrors.push({ location: GENERAL_ERROR_MESSAGES.FAILED_LOAD_LOCATIONS });
            }
          }

          // Iterate through each data row (skip header at index 0)
          for (let rowIndex = 1; rowIndex < sheetData.length; rowIndex++) {
            if (!sheetData[rowIndex] || sheetData[rowIndex].length === 0) continue;

            const rowCells = sheetData[rowIndex];
            let rowData = {
          task_type: "",
          description: rowCells[0],
          category: (rowCells[1] || "").toString().trim(),
          subcategory: (rowCells[2] || "").toString().trim()
            };

            // Parse list-type fields (split by commas, trim empties)
            // Utility to parse comma-separated fields into trimmed, non-empty arrays
            rowData.location    = parseCommaSeparatedField(rowCells[3]);
            rowData.assertions  = parseCommaSeparatedField(rowCells[4]);
            rowData.purpose     = rowCells[5];
            rowData.instruction = rowCells[6];
            rowData.preparer    = parseCommaSeparatedField(rowCells[7]);
            rowData.approver    = parseCommaSeparatedField(rowCells[8]);
            rowData.tags        = parseCommaSeparatedField(rowCells[9]);
            rowData.duedays     = (rowCells[10] !== undefined && rowCells[10] !== null && rowCells[10] !== "")
              ? Number(rowCells[10])
              : null;
            rowData.glcode      = parseCommaSeparatedField(rowCells[11]);
            rowData.priority    = rowCells[12] || "Medium";
            rowData.no_of_evidence = Number(rowCells[13] || "") || 0;
            rowData.skipValidations = ['yes', 'true', '1'].includes((rowCells[14] || '').toString().trim().toLowerCase()) || rowCells[14] === true || rowCells[14] === 1;



            // Derive task type based on presence of GL Codes
            rowData.task_type = rowData.glcode.length
          ? this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION
          : this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;

            let customFieldObjects = [];
            const rowValidationErrors = {};

            // Validate and attach custom columns (if any)
            if (this.customColumns.length > 0) {
              customFieldObjects = this.customColumns.map((customColumn) => {
                // Search for header with date suffix if it's a date column
                let headerSearchValue = customColumn.displayText;
                if (customColumn.dataType === 'date') {
                  headerSearchValue = `${customColumn.displayText} (dd/mm/yyyy)`;
                }
                
                const customColumnIndex = expectedHeadings.indexOf(headerSearchValue);
                let rawValue;
                if(customColumn.dataType === 'date' ){
                   rawValue = customColumnIndex >= 0 ? formatDateToDMY(rowCells[customColumnIndex]) : '';
                } else{
                    rawValue = customColumnIndex >= 0 ? rowCells[customColumnIndex] : '';
                }
                let formattedValue = rawValue || '';
                if (formattedValue) {
                  if (customColumn.dataType === 'number' && isNaN(Number(formattedValue))) {
                    addError(rowValidationErrors, customColumn.columnName, `'${formattedValue}' ${CHECKLIST_VALIDATION_MESSAGES.INVALID_NUMBER}`);
                  } else if (customColumn.dataType === 'date' && !parseDueDateValue(formattedValue)) {
                    addError(rowValidationErrors, customColumn.columnName, `'${formattedValue}' ${CHECKLIST_VALIDATION_MESSAGES.INVALID_DATE}`);
                  }
                }
                return { [customColumn.columnName]: formattedValue };
              });

              // Flatten custom fields into rowData
              rowData = {
                ...rowData,
                ...customFieldObjects.reduce((accumulator, fieldObject) => ({ ...accumulator, ...fieldObject }), {})
              };
            }
            rowData.customfields = customFieldObjects;

            // Required field checks
            if ((rowData.description || "").toString() === "") addError(rowValidationErrors, "description", CHECKLIST_VALIDATION_MESSAGES.DESCRIPTION_REQUIRED);
            if ((rowData.category || "").toString() === "") addError(rowValidationErrors, "category", CHECKLIST_VALIDATION_MESSAGES.CATEGORY_REQUIRED);
            if ((rowData.subcategory || "").toString() === "") addError(rowValidationErrors, "subcategory", CHECKLIST_VALIDATION_MESSAGES.SUBCATEGORY_REQUIRED);
            if (rowData.location.length === 0) addError(rowValidationErrors, "location", CHECKLIST_VALIDATION_MESSAGES.LOCATION_REQUIRED);
            if (rowData.preparer.length === 0) addError(rowValidationErrors, "preparer", CHECKLIST_VALIDATION_MESSAGES.PREPARER_REQUIRED);
            if (rowData.approver.length === 0) addError(rowValidationErrors, "approver", CHECKLIST_VALIDATION_MESSAGES.APPROVER_REQUIRED);
            // Tags validation - required for master checklist, optional for project-level
            if (!this.project && (rowData.tags || []).length === 0) {
              addError(rowValidationErrors, "tags", CHECKLIST_VALIDATION_MESSAGES.TAGS_REQUIRED);
            }
            // Keep tags for all contexts (master and project)

            // Preparer / Approver overlap validation
            const activeUserEmails = this.activeUsers?.map(user => user?.email) || [];
            if (rowData.preparer.length > 0 && rowData.approver.length > 0) {
              const inactivePreparers = rowData.preparer.filter(userEmail =>
                !activeUserEmails.includes(userEmail)
              );
              if (inactivePreparers.length > 0) {
                addError(
                  rowValidationErrors,
                  "preparer",
                  `${CHECKLIST_VALIDATION_MESSAGES.INACTIVE_PREPARER}: ${inactivePreparers.join(", ")}`
                );
              }
              // Check approvers
              const inactiveApprovers = rowData.approver.filter(userEmail =>
                !activeUserEmails.includes(userEmail)
              );
              if (inactiveApprovers.length > 0) {
                addError(
                  rowValidationErrors,
                  "approver",
                  `${CHECKLIST_VALIDATION_MESSAGES.INACTIVE_APPROVER}: ${inactiveApprovers.join(", ")}`
                );
              }
          const duplicateUsers = rowData.preparer.filter(preparerUser =>
            rowData.approver.indexOf(preparerUser.trim()) > -1
          );
          if (duplicateUsers.length > 0) {
            addError(
              rowValidationErrors,
              "preparer",
              `'${duplicateUsers.join(",")}' ${CHECKLIST_VALIDATION_MESSAGES.PREPARER_APPROVER_OVERLAP}`
            );
          }
            }

            // GL Code validation
            if (rowData.glcode.length > 0 && validGlCodeSet.size > 0) {
          const invalidGlCodes = rowData.glcode.filter(glCode => glCode && !validGlCodeSet.has(glCode));
          if (invalidGlCodes.length > 0) {
            addError(
              rowValidationErrors,
              "glcode",
              `${invalidGlCodes.join(", ")} ${CHECKLIST_VALIDATION_MESSAGES.INVALID_GL_CODE}`
            );
          }
            }

            // Category & Sub Category COA validation for AC tasks
            if (rowData.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION && coaCategorySet.size > 0) {
              if (rowData.category && !coaCategorySet.has(rowData.category)) {
                addError(
                  rowValidationErrors,
                  "category",
                  `${rowData.category} - ${CHECKLIST_VALIDATION_MESSAGES.INVALID_CATEGORY}`
                );
              }
              if (rowData.subcategory && !coaSubcategorySet.has(rowData.subcategory)) {
                addError(
                  rowValidationErrors,
                  "subcategory",
                  `${rowData.subcategory} - ${CHECKLIST_VALIDATION_MESSAGES.INVALID_SUBCATEGORY}`
                );
              }
            }

            // Due days required validation
            if (rowData.duedays === null || rowData.duedays === '') {
              addError(rowValidationErrors, "duedays", "Due Days is required");
            }

            // Due days numeric validation
            if (
          rowData.duedays !== null &&
          (isNaN(rowData.duedays) || !Number.isFinite(rowData.duedays))
            ) {
          addError(rowValidationErrors, "duedays", `'${rowCells[10]}' ${CHECKLIST_VALIDATION_MESSAGES.INVALID_NUMBER}`);
            }

            // Due days range validation (-200 to 200)
            if (
          rowData.duedays !== null &&
          !isNaN(rowData.duedays) &&
          Number.isFinite(rowData.duedays) &&
          (rowData.duedays < -200 || rowData.duedays > 200)
            ) {
          addError(rowValidationErrors, "duedays", CHECKLIST_VALIDATION_MESSAGES.DUE_DAYS_OUT_OF_RANGE);
            }

            // Location validation (case-insensitive)
            if (this.validLocationsSet && rowData?.location?.length > 0) {
                const invalidLocations = rowData.location
                  .map(loc => loc && loc.toString().trim())
                  .filter(loc => loc && !this.validLocationsSet.has(loc.toLowerCase()));
                if (invalidLocations.length > 0) {
                  addError(
                    rowValidationErrors,
                    "location",
                    `${invalidLocations.join(", ")} ${CHECKLIST_VALIDATION_MESSAGES.INVALID_LOCATION}`
                  );
                }
              }

            if (Object.keys(rowValidationErrors).length > 0) {
          this.flag = true;
            }

            parsedRows.push(rowData);
            perRowErrors.push(rowValidationErrors);
          }

          // Assign parsed data and normalized errors to component state
          this.uploaddata = parsedRows;
          this.dataerror = normalizeErrorData(perRowErrors);
          this.errorsonly = this.dataerror;
          this.dialog = true;
        })
        // Catch-all (excluding controlled "handled" stop)
        .catch(errorObject => {
          if (!errorObject) {
            // Silently ignore controlled flow interruption
          } else {
            this.$store.commit("sbError", errorObject.message || errorObject || GENERAL_ERROR_MESSAGES.UNKNOWN_ERROR);
            console.log(errorObject);
          }
        })
        // Always reset processing state
        .finally(() => {
          this.file = null;
          this.fileprocessing[key] = 0;
          this.loading = false;
        });
        }
      },
      /**
       * Read and validate trial balance Excel file
       * Processes trial balance-specific columns and validation rules
       */
      async readTrialBalanceFile(key) {
        let file = this.file[0];

        if ((file || {}).name && (this.fileprocessing[key] || 0) === 0) {
          this.fileprocessing[key] = 1;
          this.uploaddata = [];
          let ext = ((file || {}).name || '').split('.').pop();
          let possibleglcodes = [];

          try {
            const dt = await this.axios.post('/v2/financialclose/analysis/getpossibleglcodes');
            if (dt.data.status === 'success') {
              for (const i of dt.data.data) {
                possibleglcodes.push(i.glcode);
              }
            } else throw Error(GENERAL_ERROR_MESSAGES.ERROR_READING_GLCODES);

            if (['xlsx', 'xls', 'xlsm', 'xlsb'].indexOf(ext) === -1) {
              throw new Error(GENERAL_ERROR_MESSAGES.EXTENSION_NOT_SUPPORTED);
            }

            const dt2 = await this.$nova.readExcelFile(file);
            
            // Normalize headers for comparison (trim spaces, handle case)
            const actualHeaders = (dt2[0] || []).map(h => (h || '').toString().trim());
            const expectedHeaders = [
              'Account No',
              'Opening Amount',
              'Transaction',
              'Audit Entries',
              'Closing Amount',
              'Location'
            ];
            
            // Check if headers match
            const headersMatch = JSON.stringify(actualHeaders) === JSON.stringify(expectedHeaders);
            
            if (headersMatch) {
              let grouplist = [];
              for (let i = 0; i < dt2.length; i++) {
                if (i > 0) {
                  const el = dt2[i];
                  let gname = (el[0] || '').toString();
                  if (gname !== '' && grouplist.indexOf(gname) === -1) grouplist.push(gname);
                }
              }
              let groupdata = {};
              let grouporder = [];
              let errordata = {};
              this.tberrorflag = false;
              let gstartnum = 1;
              for (let i = 0; i < dt2.length; i++) {
                if (i > 0) {
                  const el = dt2[i];
                  let gname = ''.toString();
                  if (gname === '') {
                    let newgname = 'g' + (gstartnum || '').toString();
                    while (grouplist.indexOf(newgname) !== -1) {
                      newgname = 'g' + (gstartnum || '').toString();
                      gstartnum = gstartnum + 1;
                    }
                    gname = newgname;
                    if (grouplist.indexOf(gname) === -1) grouplist.push(gname);
                  }
                  groupdata[gname] = groupdata[gname] || [];
                  groupdata[gname].push({
                    group: gname,
                    glcode: el[0],
                    opening_amount: el[1],
                    transaction: el[2],
                    audit_entries: el[3],
                    closing_amount: el[4],
                    location: el[5]
                  });
                  if (gname !== '' && grouplist.indexOf(gname) === -1) grouplist.push(gname);
                  if (grouporder.indexOf(gname) === -1) grouporder.push(gname);
                  errordata[gname] = errordata[gname] || [];
                  let errors = ['', '', ''];
                  let glcode = (el[0] || '').toString();
                  if (glcode === '') errors[1] = TRIAL_BALANCE_VALIDATION_MESSAGES.GL_CODE_REQUIRED;
                  else if (possibleglcodes.indexOf(glcode) === -1)
                    errors[1] = TRIAL_BALANCE_VALIDATION_MESSAGES.GL_CODE_NOT_FOUND;
                  if (errors.join('') !== '') this.tberrorflag = true;
                  errordata[gname].push(errors);
                }
              }
              this.uploaddata = [];
              this.dataerror = [];

              for (const i of grouporder) {
                this.uploaddata.push({ group: i, data: groupdata[i] });
                this.dataerror.push(errordata[i]);
              }
              
              // Use shared utility to flatten errors
              const flattenedErrors = this.flattenTrialBalanceErrors(errordata, grouporder);
              this.errorsonly = flattenedErrors.length > 0 ? flattenedErrors : [];
              this.dialog = true;
            } else {
              // Show header mismatch errors one by one
              const headerErrors = [];
              headerErrors.push(HEADER_ERROR_MESSAGES.HEADER_MISMATCH);
              
              // Show expected headers
              headerErrors.push(HEADER_ERROR_MESSAGES.EXPECTED_HEADERS(expectedHeaders));
              
              // Show found headers
              headerErrors.push(HEADER_ERROR_MESSAGES.FOUND_HEADERS(actualHeaders));
              
              // Additional instruction
              headerErrors.push(HEADER_ERROR_MESSAGES.ENSURE_ORDER);
              
              // Set header error messages and flags
              this.headerErrorMessages = headerErrors;
              this.haserror = true;
              this.tberrorflag = true;
              this.uploaddata = [];
              this.dataerror = [];
              this.errorsonly = [];
              this.dialog = true;
            }
          } catch (err) {
            // Show all errors in drawer (non-header errors)
            const errorMsg = err.message || err || GENERAL_ERROR_MESSAGES.UNKNOWN_ERROR;
            this.showErrorInDrawer(errorMsg, false); // false = data error
            console.log(err);
          } finally {
            this.file = null;
            this.fileprocessing[key] = 0;
          }
        }
      },
      // ============================================
      // DATA UPLOAD METHODS
      // ============================================
      
      /**
       * Main upload dispatcher - routes to appropriate upload handler
       */
      uploadData() {
        if (this.uploadType === 'checklist') {
          this.uploadChecklistData();
        } else if (this.uploadType === 'trialbalance') {
          this.uploadTrialBalanceData();
        }
      },
      
      /**
       * Upload checklist data to server
       */
      uploadChecklistData() {
        this.loading = true;
        let url = "/v2/financialclose/masters/checklist/bulkadd";
        if(this.project) url = "/v2/financialclose/analysis/bulkaddchecklist/"+this.project;
        let data = this.uploaddata.map(a => ({...a,cycle_type: this.cycle_type}))
        this.axios.post(url, { data: data }).then(dt => {
          if (dt.data.status === "success") {
            this.dialog = false;
            this.$emit('reload');
            this.$store.commit("sbSuccess", "Tasklist uploaded successfully");
          } else throw dt.data.message || GENERAL_ERROR_MESSAGES.ERROR_UPLOADING_CHECKLIST;
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || GENERAL_ERROR_MESSAGES.UNKNOWN_ERROR);
          console.log(err);
        }).finally(() => {
          this.loading = false;
        })
      },
      /**
       * Upload trial balance data to server
       * Includes validation for duplicate accounts with empty locations
       */
      uploadTrialBalanceData() {
        let errorRows = [];
        const emptyLocationAccNos = new Set();
        for (const row of this.existingTrialBalanceData) {
          if (
            (typeof row.location === 'string' && row.location.trim() === '') ||
            row.location === undefined ||
            row.location === null ||
            (Array.isArray(row.location_detail) && row.location_detail.length === 0)
          ) {
            emptyLocationAccNos.add(String(row.glcode));
          }
        }
        for (let idx = 0; idx < this.uploaddata.length; idx++) {
          const i = this.uploaddata[idx];
          const accNo = (i.data[0] || {}).glcode;
          const location = (i.data[0] || {}).location;
          if ((!location || location === '') && emptyLocationAccNos.has(String(accNo))) {
            errorRows.push(idx);
          }
        }
        for (const idx of errorRows) {
          if (!this.dataerror[idx]) this.dataerror[idx] = [[]];
          this.dataerror[idx][0][5] = TRIAL_BALANCE_VALIDATION_MESSAGES.DUPLICATE_ACCOUNT_EMPTY_LOCATION;
        }
        if (errorRows.length > 0) {
          this.tberrorflag = true;
          this.loading = false;
          return;
        }
        this.loading = true;
        let ndt = [];
        for (const i of this.uploaddata) {
          ndt.push(i.data[0]);
        }
        this.axios
          .post('/v2/financialclose/analysis/bulkaddtb/' + this.project, { data: ndt })
          .then(dt => {
            if (dt.data.status === 'success') {
              this.dialog = false;
              this.$emit('reload');
              this.$store.commit('sbSuccess', 'TB uploaded successfully');
            } else throw dt.data.message || GENERAL_ERROR_MESSAGES.ERROR_UPLOADING_TB;
          })
          .catch(err => {
            this.$store.commit('sbError', err.message || err || GENERAL_ERROR_MESSAGES.UNKNOWN_ERROR);
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // ============================================
      // UTILITY & HELPER METHODS
      // ============================================
      
      /**
       * Update files from drag-drop component
       * Handles different file formats for checklist vs trial balance
       */
      updateFilesBulk(newFilesBulk) {
        this.file = this.uploadType === 'trialbalance' ? newFilesBulk : newFilesBulk[0];
        this.readFile('file')
      },
      
      /**
       * Get cell value from row based on upload type structure
       */
      getCellValue(row, key) {
        if (this.uploadType === 'trialbalance') {
          return (row.data && row.data[0]) ? row.data[0][key] : '';
        }
        return row[key] || '';
      },
      
      /**
       * Format cell value based on specified format type
       */
      formatCellValue(value, format) {
        if (format === 'number') {
          return this.formatNum(value);
        }
        return value;
      },
      
      /**
       * Format number with locale-specific formatting
       */
      formatNum(input) {
        let number = Number(input);
        if (isNaN(number) || input === null || input === undefined || input === '') {
          return '';
        }
        return number.toLocaleString('en-US');
      },
    },
    watch: {
      /**
       * Watch for changes in error filter toggle
       * Filters error display based on upload type structure
       */
      showdatawitherror(newVal) {
        if (!newVal) {
          // Show all data (including rows without errors)
          this.errorsonly = this.dataerror;
          return;
        }
        
        // Filter to show only rows with errors based on upload type
        if (this.uploadType === 'checklist') {
          // Checklist: flat error object structure
          this.errorsonly = this.dataerror.filter(item => Object.keys(item).length > 0);
        } else if (this.uploadType === 'trialbalance') {
          // Trial Balance: nested array error structure
          this.errorsonly = this.dataerror.filter(item =>
            Array.isArray(item) && item.some(innerArray => 
              Array.isArray(innerArray) && innerArray.some(value => value && value.trim() !== '')
            )
          );
        }
      }
    },
    computed:{
      /**
       * Dynamic drawer heading based on upload type
       */
      drawerHeading() {
        return 'Bulk Upload';
      },
      
      /**
       * Computed table headers based on upload type
       * Returns different column configurations for checklist vs trial balance
       */
      computedHeaders() {
        // Use custom headers if provided
        if (this.tableHeaders && this.tableHeaders.length > 0) {
          return this.tableHeaders;
        }
        
        // Trial Balance Headers
        if (this.uploadType === 'trialbalance') {
          return [
            { text: 'Account No.', value: 'glcode', align: 'left', errorIndex: 1 },
            { text: 'Opening Amount', value: 'opening_amount', align: 'right', format: 'number' },
            { text: 'Transaction', value: 'transaction', align: 'right', format: 'number' },
            { text: 'Journal Entries', value: 'audit_entries', align: 'right', format: 'number' },
            { text: 'Closing Amount', value: 'closing_amount', align: 'right', format: 'number' },
            { text: this.$store.state.LocationHeader || 'Location', value: 'location', align: 'left', errorIndex: 5 }
          ];
        } else {
          // Checklist Headers
          const baseHeaders = [
            { text: 'Task Type', value: 'task_type' },
            { text: 'Description', value: 'description' },
            { text: 'Category', value: 'category' },
            { text: 'Sub Category', value: 'subcategory' },
            { text: 'Location', value: 'location' },
            { text: 'Assertions', value: 'assertions' },
            { text: 'Purpose', value: 'purpose' },
            { text: 'Instruction', value: 'instruction' },
            { text: 'Preparer', value: 'preparer' },
            { text: 'Approver', value: 'approver' },
            { text: 'Tags', value: 'tags' }
          ];
          
          baseHeaders.push(
            { text: 'Due days', value: 'duedays' },
            { text: 'Account No.', value: 'glcode' },
            { text: 'Priority', value: 'priority' },
            { text: 'No. of Evidences', value: 'no_of_evidence' },
            { text: 'Skip Validation', value: 'skipValidations' }
          );
          
          if (this.customColumns && this.customColumns.length > 0) {
            this.customColumns.forEach(col => {
              // Add date suffix for date-type custom columns
              const headerText = col.dataType === 'date' 
                ? `${col.displayText} (dd/mm/yyyy)` 
                : col.displayText;
              baseHeaders.push({ text: headerText, value: col.columnName });
            });
          }
          
          return baseHeaders;
        }
      },
      
      /**
       * Filtered data for display based on error filter toggle
       * Handles different data structures for checklist vs trial balance
       */
      filteredData() {
        if (this.showdatawitherror) {
          // Filter by upload type
          if (this.uploadType === 'checklist') {
            return this.uploaddata.filter((_, rowIndex) =>
              Object.values(this.dataerror[rowIndex] || {}).some((error) => error)
            );
          } else if (this.uploadType === 'trialbalance') {
            return this.uploaddata.filter((_, index) => {
              const hasError = this.dataerror[index]?.some(errors =>
                errors.some(msg => msg && msg.trim() !== '')
              );
              return hasError;
            });
          }
        }
        return this.uploaddata;
      }
    }
  }
  </script>

<style scoped>
.border-red {
  border: 1px solid #f3b9ba !important;
}
</style>